module.exports = __webpack_public_path__ + "img/service-6.13a19ea6.png";